import { Modal } from '../../components/modals/Modal';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Fade, IconButton, Typography, CircularProgress, Tooltip, Paper } from '@mui/material';
import { useState } from 'react';
import { copyTextToClipboard, invokeIfCallable } from '../../library/shared';
import PrintIcon from '@mui/icons-material/Print';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Email, WhatsApp } from '@mui/icons-material';
import { checkandopenpdf, fetchAndPrintPDF } from '../../utils/common';
import pdfImage from '../../assets/images/attachments/pdf.png';
import API_ENDPOINTS from '../../apiEndpoints';
import { showWarningSnackbar } from '../snackBar/snakbar';
import { SendEmailModalWrapper, useSendEmailModal } from '../../features/Email';

export const ShareModal = ({
  open = '',
  setOpen,
  shareUrl,
  title,
  createURl,
  print,
  page,
  onClose,
  emailData = {},
  text,
  progress = {},
}) => {

  // const [progress, setprogress] = useState({isLoading:true})

  let handleClose = (_, reason) => {
    console.log(_, reason);
    if (reason !== 'backdropClick') {
      invokeIfCallable(onClose);
      setOpen('');
    }
  };
  let url =
    String(open || '')?.indexOf(API_ENDPOINTS.REACT_APP_S3_BUCKET_URL) >= 0 ? open : API_ENDPOINTS.REACT_APP_S3_BUCKET_URL + '/' + open;
  const [loading, setloading] = useState({
    copy: false,
  });

  const share = (e) => {
    console.log(shareUrl, title, url);
    return createURl(url);
  };
  const shareINVOICE = (URI, status) => {
    console.log(URI, status);
    shareUrl = URI;
    setOpen(status);
    title = 'Invoice';
  };
  const copy = async () => {
    try {
      setloading((prev) => ({ ...prev, copy: true }));
      // await createURl(url)
      copyTextToClipboard(url, 'Link copied');
    } catch (error) {
      console.log(error);
    } finally {
      setloading((prev) => ({ ...prev, copy: false }));
    }
  };

  const openMail = (body, subject) => {
    if (!progress?.isLoading) {
      const encodedSubject = encodeURIComponent(subject);
      const encodedBody = encodeURIComponent(body);
      const mailtoLink = `mailto:?subject=${encodedSubject}&body=${encodedSubject + ' \n' + encodedBody}`;
      window.location.href = mailtoLink;
    }
  };

  const getVoucherTypeFromUrl = (url) => {
    const voucherTypes = {
      journalentry: 'Journal Entry',
      creditnote: 'Credit Note',
      debitnote: 'Debit Note',
      sales: 'Sales',
      purchase: 'Purchase',
      payment: 'Payment',
      receipt: 'Receipt',
    };
    const lowerUrl = url.toLowerCase();
    const matchedType = Object.keys(voucherTypes).find((type) => lowerUrl.includes(type));
    return matchedType ? voucherTypes[matchedType] : null;
  };
  const openWhatsApp = (title) => {
    title = title || getVoucherTypeFromUrl(url);
    const message = encodeURIComponent(`${title} ${url}`);
    const uri = `https://web.whatsapp.com/send?text=${message}`;
    const width = window.screen.width;
    const height = window.screen.height;
    const left = 0;
    const top = 0;
    const newWindow = window.open(
      uri,
      '_blank',
      `toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=${width},height=${height},top=${top},left=${left}`
    );
    if (newWindow) {
      // Try to request fullscreen (may not work in all browsers)
      newWindow.moveTo(0, 0);
      newWindow.resizeTo(window.screen.width, window.screen.height);
    }
  };
  const handlePrint = () => {
    // Open the PDF in a new tab
    const printWindow = window.open(open);

    // Wait for the window to fully load the PDF
    printWindow.onload = () => {
      printWindow.focus(); // Focus on the new window
      printWindow.print(); // Trigger the print dialog
    };
  };

  const { openModal, modalProps } = useSendEmailModal();

  const onCloseCb = () => {
  };

  const handleEmailSend = () => {
    if (emailData?.selectedRow.length > 0 && emailData?.type !== '') {
      // For POS invoices, skip the party account validation as they don't have party IDs
      if (emailData?.type !== 'pos') {
        const nonPartyAccounts = emailData.selectedRow?.filter((item) => !item.recipientId);
        if (nonPartyAccounts.length > 0) {
          showWarningSnackbar('Selected accounts contain non-party accounts. Only customer/supplier accounts can receive emails.');
          return;
        }
      }
      openModal(emailData?.type, emailData?.selectedRow, onCloseCb);
    }
  };
  return (
    <Modal onClose={handleClose} open={open}>
      <Paper>
        <Modal.Header>
          <Box
            sx={{
              backgroundColor: 'primary.main',
              padding: ' 0 15px 0 15px ',
              display: 'flex',
              flexDirection: 'row',
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  color: '#ffffff',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  fontWeight: '500',
                }}
              >
                {/* Share */}
                Share this {text || 'Invoice'}!
                <IconButton aria-label="delete" onClick={() => handleClose()}>
                  <CloseIcon sx={{ color: '#fff' }} />
                </IconButton>
              </Typography>
            </Box>
          </Box>
        </Modal.Header>
        <Modal.Body>
          <Fade in={open}>
            <Box
              sx={{
                margin: 'auto',
              }}
            >
              <Box
                sx={{
                  // margin: "auto",
                  marginBottom: '15px',
                  // display: "flex",
                  justifyContent: 'center',
                  // width: "95%",
                  // height: { xs: "150px", sm: "auto" },
                  overflowY: { xs: 'scroll', sm: 'hidden' },
                  minWidth: { xs: '300px', lg: '350px' },
                  padding: '25px',
                }}
              >
                {progress?.isLoading !== undefined && (
                  <p className={`py-4 ${progress?.isLoading ? 'loading' : 'loaded'}`}>
                    {progress.isLoading ? (
                      <span className="loading-text">
                        Generating Pdf<span className="dot">.</span>
                        <span className="dot">.</span>
                        <span className="dot">.</span>
                      </span>
                    ) : (
                      <span className="fade-in">Pdf Generated</span>
                    )}
                  </p>
                )}
                {/* <button onClick={() => setprogress((prev)=>({...prev,isLoading:!prev.isLoading}))}>test</button> */}

                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: 1,
                    padding: '5px 10px',
                    justifyContent: 'center',
                  }}
                >
                  {page != 'purchase' && (
                    <>
                      <Tooltip placement="top" title={`WhatsApp ${progress?.isLoading ? '' : ''}`} arrow>
                        <Box
                          style={{
                            width: '48px',
                            height: '48px',
                            borderRadius: '500px',
                            backgroundColor: progress?.isLoading ? '#636363' : '#25D366',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            cursor: progress?.isLoading ? 'wait' : 'pointer',
                            transition: 'background-color 0.9s ease',
                          }}
                        >
                          <WhatsApp
                            sx={{ color: '#ffff', fontSize: '25px' }}
                            onClick={() => (progress?.isLoading ? null : openWhatsApp('', open))}
                            round
                          />
                        </Box>
                      </Tooltip>

                      <Tooltip placement="top" title="Mail" arrow>
                        <Box
                          style={{
                            width: '48px',
                            height: '48px',
                            borderRadius: '500px',
                            backgroundColor: progress?.isLoading ? '#636363' : '#911b7ca3',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            cursor: progress?.isLoading ? 'wait' : 'pointer',
                            transition: 'background-color 1.1s ease',
                          }}
                        >
                          <Email
                            style={{ color: '#ffff' }}
                            onClick={() =>
                              progress?.isLoading
                                ? null
                                : handleEmailSend
                                ? handleEmailSend()
                                : openMail('subject test', `hello check this ${open}</a>`)
                            }
                            size={48}
                            round
                          />
                        </Box>
                      </Tooltip>
                      <Tooltip placement="top" title="Copy web link to share" arrow>
                        <Box
                          sx={{
                            width: '48px',
                            height: '48px',
                            borderRadius: '500px',
                            backgroundColor: progress?.isLoading ? '#636363' : '#911b7ca3',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            cursor: progress?.isLoading ? 'wait' : 'pointer',
                            transition: 'background-color 1.3s ease',
                          }}
                          onClick={() => (progress?.isLoading ? null : copy())}
                        >
                          {' '}
                          {loading.copy === true ? <CircularProgress size={'20px'} /> : <ContentCopyIcon sx={{ color: 'white' }} />}
                        </Box>
                      </Tooltip>
                    </>
                  )}
                  <Tooltip placement="top" title="Print" arrow>
                    <Box
                      sx={{
                        width: '48px',
                        height: '48px',
                        borderRadius: '500px',
                        backgroundColor: progress?.isLoading ? '#636363' : '#911b7ca3',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        cursor: progress?.isLoading ? 'wait' : 'pointer',
                        transition: 'background-color 1.5s ease',
                      }}
                      onClick={() => (progress?.isLoading ? null : fetchAndPrintPDF(url))}
                    >
                      <PrintIcon sx={{ color: 'white' }} color="white" />
                    </Box>
                  </Tooltip>
                  <Tooltip placement="top" title="Download" arrow>
                    <Box
                      // download="01.pdf"
                      // target="_blank"
                      // href={`https://ledgerx365.s3.amazonaws.com/${url}`}
                      onClick={() => {
                        if (progress?.isLoading) {
                          return null;
                        }
                        checkandopenpdf(url);
                      }}
                      style={{
                        width: '48px',
                        height: '48px',
                        borderRadius: '500px',
                        backgroundColor: progress?.isLoading ? '#636363' : '#911b7ca3',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        cursor: progress?.isLoading ? 'wait' : 'pointer',
                        overflow: 'hidden',
                      }}
                    >
                      <img
                        alt="pdf"
                        src={pdfImage}
                        style={{
                          height: '55px',
                          transition: 'filter 1.7s ease',

                          filter: progress?.isLoading ? 'grayscale(1)' : '',
                        }}
                      />
                    </Box>
                  </Tooltip>
                </Box>
              </Box>
            </Box>
          </Fade>
        </Modal.Body>
      </Paper>
      <SendEmailModalWrapper {...modalProps} />
    </Modal>
  );
};
